Ext.define('SA.VectorMapChoroplethLocationsTileSourceUrls', {
    singleton: true,

    get({attributes, filter, geographicRelease, geoUnits}) {
        var attribute = attributes.selected,
            geoUnit = geoUnits.selected,
            select = ['locationSeries', 'name', 'can:populationRank', 'usa:populationRank'],
            locationSeries = ['=', 'geographicUnit', geoUnit];

        if (attribute) {
            select.push(attribute);
        }

        if (filter) {
            select.push(...filter.getAttributes());
        }

        return [SA.VectorMapTileSourceUrls.get({geographicRelease, locationSeries, select: SA.Array.unique(select)})];
    }
});